import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { Alert } from '../_models';
import { BaseService } from './base.service';
import { DatatablesUtils } from '../_utils/datatables';

export class Alerts {
  alerts: Alert[];
  total: number;
}

@Injectable()
export class AlertService extends BaseService {
  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/alerts`);
  }

  listPage(urlParams: any, params: any, dtParams: any): Observable<Alerts> {
    const url = sprintf(this.baseUrl, urlParams);
    const apiParams = DatatablesUtils.convertToApiParams(dtParams);
    return this.http.get<Alerts>(url, {
      params: this.toHttpParams({
        ...params,
        ...apiParams,
      })
    });
  }
}
